import type { SEOData } from '$lib/components/seo/types';
import type { AvailableLanguageTag } from '$paraglide/runtime';
import type { PageLoadEvent } from './$types';
import { segments2routeSegments } from '$lib/i18n/routing';
import { fillItinerarySearchData } from '$lib/seo/faq/itinerary';
import { pageIsSEOIndexable } from '$lib/seo/utils';
import { isVanitySearchParams } from '$lib/services/urls/vanity';

interface GetPageSEODataArgs {
	lang: AvailableLanguageTag;
}

export function getPageSeoData(event: PageLoadEvent, { lang }: GetPageSEODataArgs): SEOData {
	const { faqPageData, title, description, staticFooterData } = event.data;

	const faq = faqPageData?.map((entry) => {
		return fillItinerarySearchData({
			question: entry.question,
			answer: entry.response,
			lang,
		});
	});

	const isVanityUrl = isVanitySearchParams(event.url);

	return {
		header: {
			og: {
				title,
				description,
			},
			pathWithoutAddress: '/routes',
			allowIndex: pageIsSEOIndexable(event.url, {}, isVanityUrl),
			showAlternates: isVanityUrl,
		},
		footer: {
			title,
			description,
			crumbs: segments2routeSegments(['routes'], lang, true),
			data: staticFooterData,
			faq,
		},
	};
}
